<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import KidSelectVoip from './KidSelectVoip.vue'

defineOptions({
  name: 'KidOtherInfo',
})
</script>

<template>
  <div class="kid-info-group">
    <AppText name="body1-medium">
      Other
    </AppText>
    <div class="kid-info-group__list">
      <KidSelectVoip />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KidInfoGroup.scss" />
